// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"f63f1f56","68":"7483e682","234":"96c8d7da","342":"ce4f7d9b","361":"85172613","463":"91aad4ad","656":"a9078d2b","719":"2dc8a56e","800":"d7fdb1f0","857":"07717cbc","864":"db9a5e8e","877":"f9d243d0","891":"4bbda966"}[chunkId] + ".chunk.js";
};